import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../common/hooks/useAppDispatch';
import { useAppSelector } from '../hooks/useAppSelector';
import {
  updateEmployee,
  setEditingEmployee,
  updateEditingEmployee,
  clearEditingEmployee,
  selectEditingEmployee,
  selectEmployeesStatus,
} from '../../slices/employees/employeesSlice';
import { Employee } from '../../models/employee.model';
import { useState } from 'react';

export function useEmployeeDetailsCardForm(employee: Partial<Employee>) {
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState(false);
  const [showAddSocialModal, setAddSocialShowModal] = useState(false);
  const formRef = useRef<HTMLDivElement | null>(null);

  // Get editing state from Redux
  const editingEmployee = useAppSelector(selectEditingEmployee);
  const status = useAppSelector(selectEmployeesStatus);
  const isEdited = !!editingEmployee && editingEmployee.id === employee.id;

  // Initialize the editing employee in Redux if needed
  useEffect(() => {
    if (employee && !editingEmployee && isEdited) {
      dispatch(setEditingEmployee(employee));
    }
  }, [employee, editingEmployee, dispatch, isEdited]);

  const handleChange =
    <K extends keyof Employee>(field: K) =>
    (value: Employee[K]) => {
      if (isEdited) {
        dispatch(updateEditingEmployee({ field, value }));
      }
    };

  const saveChanges = async () => {
    if (isEdited && editingEmployee) {
      dispatch(updateEmployee(editingEmployee));
      setShowModal(false);
    }
  };

  const saveChangesSocialForm = () => {
    console.log('Saved social links');
    toogleEditingSocialModal();
  };

  const toggleEditing = () => {
    if (isEdited) {
      dispatch(clearEditingEmployee());
    } else {
      dispatch(setEditingEmployee(employee));
    }
  };

  const toogleEditingSocialModal = () => {
    setAddSocialShowModal((prev) => !prev);
  };

  const confirmExit = () => {
    dispatch(clearEditingEmployee());
    setShowModal(false);
  };

  // Handle clicks outside the form
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isEdited && formRef.current && !formRef.current.contains(event.target as Node)) {
        if (event.target instanceof HTMLElement) {
          // You can add ignored elements check if needed
        }
        setTimeout(() => {
          setShowModal(true);
        }, 0);
      }
    };

    if (isEdited) document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isEdited]);

  return {
    formData: editingEmployee || employee,
    handleChange,
    saveChanges,
    isEdited,
    toggleEditing,
    formRef,
    showModal,
    setShowModal,
    confirmExit,
    showAddSocialModal,
    setAddSocialShowModal,
    toogleEditingSocialModal,
    saveChangesSocialForm,
    isLoading: status === 'loading',
  };
}
